import * as React from 'react'
import {Util} from 'yougile-util'

export interface ArrowPoint {
  x: number
  y: number
}

interface Props {
  from: ArrowPoint
  to: ArrowPoint
  highlighted?: boolean
}
const xMargin = 4

const ArrowBase = (props: Props) => {
  const {from, to, highlighted} = props
  const bem = Util.bemFrom('timeline-arrow')
  const incorrect = to.x < from.x

  const curv = incorrect ? 180 : 90

  const line = `M ${from.x} ${from.y} C ${from.x + curv} ${from.y} ${
    to.x + xMargin - curv
  } ${to.y} ${to.x + xMargin} ${to.y}`
  const arrow = `M ${to.x + xMargin} ${to.y} L ${to.x + xMargin - 7} ${
    to.y - 5
  } L ${to.x + xMargin - 7} ${to.y + 5} Z`

  return (
    <>
      {(from.x !== to.x || from.y !== to.y) && (
        <>
          <circle
            className={bem('area', {incorrect, highlighted})}
            cx={from.x - xMargin}
            cy={from.y}
            r={xMargin}
          />
          <path className={bem('line', {incorrect, highlighted})} d={line} />
        </>
      )}
      <path className={bem('area', {incorrect, highlighted})} d={arrow} />
    </>
  )
}

export const Arrow = (props: Props) => {
  return <ArrowBase {...props} />
}
